import configuration from "../Configuration";

export type EnvironmentName = "development" | "production";

export function isBrowserContext()
{
    return typeof window !== "undefined" && typeof window.document !== "undefined";
}

export function getEnvironment(): EnvironmentName
{
    return process.env.NODE_ENV as EnvironmentName;
}

export function isProduction()
{
    return getEnvironment() === "production";
}

export function isDevelopment()
{
    return getEnvironment() === "development";
}

export function getUrlOrigin()
{
    return isBrowserContext()
        ? isDevelopment() ? configuration.baseURL : window.location.origin
        : globalThis.origin as string;
}